import './scss/style.scss'
import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { slk } from 'survey-core'

import { ImporterProvider } from './contexts/ImporterContext'
import { CreditsProvider } from './contexts/CreditsContext'
import DefaultLayout from './layout/DefaultLayout'
import LoginHandler from './LoginHandler'
import CustomAuthTemplate from './components/auth/CustomAuthTemplate'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)
function AuthenticatedRoutes() {
  const Register = React.lazy(() => import('./views/pages/register/Register'))
  const FormBuilder = React.lazy(() => import('./views/forms/FormAdd'))
  const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

  return (
    <CustomAuthTemplate>
      <ImporterProvider>
        <Suspense fallback={loading}>
          <Routes>
            <Route path="500" element={<Page500 />} />

            <Route
              path="register"
              element={
                <LoginHandler>
                  <Register />
                </LoginHandler>
              }
            />

            <Route path="admin/forms/add/:formId" element={<FormBuilder />} />

            <Route
              path="*"
              element={
                <LoginHandler>
                  <CreditsProvider>
                    <DefaultLayoutRoutes />
                  </CreditsProvider>
                </LoginHandler>
              }
            />
          </Routes>
        </Suspense>
      </ImporterProvider>
    </CustomAuthTemplate>
  )
}

function DefaultLayoutRoutes() {
  const CertificateTemplate = React.lazy(() =>
    import('./views/consignments/contents/generate/template/CertificateTemplate'),
  )
  const FormBuilder = React.lazy(() => import('./views/forms/FormAdd'))
  const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
  const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

  return (
    <DefaultLayout>
      <Routes>
        <Route path="admin/forms/add/:formId" element={<FormBuilder />} />
        <Route path="CertificateTemplate" element={<CertificateTemplate />} />
        <Route path="404" element={<Page404 />} />
        <Route path="500" element={<Page500 />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </DefaultLayout>
  )
}

function UnauthenticatedRoutes() {
  const Landing = React.lazy(() => import('./views/landing/Landing'))
  const GetStarted = React.lazy(() => import('./views/landing/GetStarted'))

  return (
    <Suspense fallback={loading}>
      <Routes>
        <Route path="get-started" element={<GetStarted />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </Suspense>
  )
}

function App() {
  slk(process.env.REACT_APP_SURVEYJS_KEY)

  return (
    <Routes>
      <Route path="/app/*" element={<AuthenticatedRoutes />} />
      <Route path="/*" element={<UnauthenticatedRoutes />} />
    </Routes>
  )
}

export default App
